import { Component, OnInit } from '@angular/core';
import { GoogleTagManagerService } from 'src/app/services/google-tag-manager.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sac-contact-link',
  templateUrl: './sac-contact-link.component.html',
  styleUrls: ['./sac-contact-link.component.scss']
})
export class SacContactLinkComponent implements OnInit {
  textBtnSac: string | undefined;
  sacUrl: string | undefined;
  textPhone: string | undefined;

  constructor(private gtmService: GoogleTagManagerService) { }

  ngOnInit(): void {
    this.textPhone=environment.contacts.textPhoneSac
    this.textBtnSac=environment.contacts.textPhoneButtonSac
  }

  async onPhoneButtonClick() {
    this.gtmService.push({
      event: 'contactSac'
    });
  }

}
